import { List, Stack, Typography } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { Bound } from "lib/@components/binding/Bound"
import { VariantPickerItem } from "./variant-picker-item"

export function VariantComparisonPicker({ ok, __cancel, variants }) {
    return (
        <Stack sx={{ p: 2 }}>
            <Typography variant="h6" sx={{ mb: 1 }}>
                Add Variant to Compare
            </Typography>
            <Bound onPickVariant={ok}>
                <List>
                    <Repeat list={variants ?? []} item={<VariantPickerItem />} />
                </List>
            </Bound>
        </Stack>
    )
}
